// @flow
export const INVOICE_FETCH = 'INVOICE_FETCH'
export const INVOICE_SUCCESS = 'INVOICE_SUCCESS'
export const INVOICE_FAIL = 'INVOICE_FAIL'

export const INVOICE_PAYING_FETCH = 'INVOICE_PAYING_FETCH'
export const INVOICE_PAYING_SUCCESS = 'INVOICE_PAYING_SUCCESS'
export const INVOICE_PAYING_FAIL = 'INVOICE_PAYING_FAIL'
